import { useTranslation } from "react-i18next";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  return (
    <div className="flex items-center bg-gray-100 rounded-md overflow-hidden">
      <button
        type="button"
        onClick={() => i18n.changeLanguage("sv")}
        className={`px-3 py-1.5 text-sm font-medium transition-colors ${
          (i18n.language || "sv").startsWith("sv")
            ? "bg-primary text-white"
            : "text-gray-700 hover:bg-gray-200"
        }`}
      >
        SV
      </button>
      <button
        type="button"
        onClick={() => i18n.changeLanguage("en")}
        className={`px-3 py-1.5 text-sm font-medium transition-colors ${
          (i18n.language || "sv").startsWith("en")
            ? "bg-primary text-white"
            : "text-gray-700 hover:bg-gray-200"
        }`}
      >
        EN
      </button>
    </div>
  );
};
